module.exports = __webpack_public_path__ + "static/img/preview.b923e5e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/work/hp-wearable/preview.jpg
// module id = k8rL
// module chunks = 1